import { createSelector } from 'reselect';

import { InvoicesState } from '~/reducers/invoices';
import Invoice from '~/types/Invoice';
import { ApplicationState } from '../store';

export const getInvoicesState = (state: ApplicationState) => state.invoices;

export const getInvoices = createSelector(
  getInvoicesState,
  (invoicesState: InvoicesState) => invoicesState.invoices,
);

export const getDisplayInvoice = createSelector(
  getInvoicesState,
  (invoicesState: InvoicesState) => invoicesState.displayInvoice,
);

export const getHasInvoices = createSelector(
  getInvoices,
  (invoices: Requestable<Refreshable<Invoice, string>[], string>): boolean =>
    Boolean(invoices.kind === 'success' && invoices.data && invoices.data.length),
);

export const getPage = createSelector(
  getInvoicesState,
  (invoicesState: InvoicesState) => invoicesState.page,
);

export const getNumPages = createSelector(
  getInvoicesState,
  (invoicesState: InvoicesState) => invoicesState.numPages,
);
